import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';

function MenuOptionsReports({sImage, sTitle, sBody, sLink, sLinkLable}) {
  return (
    <Card style={{ width: '18rem' }}>
      {/* <Card.Img variant="top" src={sImage} /> */}
      <Card.Img variant="top" style={{height:'150px',width:'150px', alignContent:'center', margin:'auto',paddingTop:'20px' }} src={sImage} />
      <Card.Body>
        <Card.Title>{sTitle}</Card.Title>
        <Card.Text>
            {/* {sBody} */}
            <Link to="/report/danecount"><Button size='sm' variant="outline-success">Dane Summary Report</Button></Link>      
        </Card.Text>
        {/* <Button variant="primary">Go somewhere</Button> */}
                
      </Card.Body>
    </Card>
  );
}

export default MenuOptionsReports;